import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { BranchWriteRequest } from '@/api/handlers/resources/branches/requests';
import type { BranchWriteResponse } from '@/api/handlers/resources/branches/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { BranchQueryKeys } from './branchQueryKeys';

export type UpdateBranchVariables = {
    id: string;
    body: BranchWriteRequest;
};

/**
 * Mutation behind the Edit Branch submit. The server enforces the single-main
 * invariant and the list ordering atomically; we invalidate the cached pages
 * on settle so the table reconciles with the authoritative `/details` order
 * and aggregates.
 */
export const useUpdateBranchMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<BranchWriteResponse>,
        Error,
        UpdateBranchVariables
    >({
        mutationFn: ({ id, body }) => apiClient.branches.updateBranch(id, body),
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: BranchQueryKeys.all });
        },
    });
};
